// 当前日期
const getNowFormatDate = () => {
  const date = new Date()
  const seperator1 = '-'
  let month = date.getMonth() + 1
  let strDate = date.getDate()
  if (month >= 1 && month <= 9) {
    month = '0' + month
  }
  if (strDate >= 0 && strDate <= 9) {
    strDate = '0' + strDate
  }
  const currentdate = date.getFullYear() + seperator1 + month + seperator1 + strDate
  return currentdate
}
// 时间函数
// 默认选中明天时间
const getNowTime = () => {
  const now = new Date()
  now.setDate(now.getDate() + 1) // 在原先的天数上增加一天
  const year = now.getFullYear() // 得到年份
  let month = now.getMonth() // 得到月份
  let date = now.getDate() // 得到日期
  month = month + 1
  month = month.toString().padStart(2, '0')
  date = date.toString().padStart(2, '0')
  const defaultDate = `${year}-${month}-${date} 08:00:00`
  return defaultDate
}
// 将日期转换为时间戳
const getUnixTime = (dateStr) => {
  const newstr = dateStr.replace(/-/g, '/')
  console.log(newstr)
  const date = new Date(newstr)
  const timeStr = date.getTime().toString()
  return timeStr.substr(0, 10)
}
// 将时间戳转为日期
const getDate = (timestamp, num) => {
  timestamp = timestamp + ''
  timestamp = timestamp.length === 10 ? timestamp * 1000 : timestamp
  var date = new Date(timestamp)
  var y = date.getFullYear()
  var m = date.getMonth() + 1
  m = m < 10 ? ('0' + m) : m
  var d = date.getDate()
  d = d < 10 ? ('0' + d) : d
  var h = date.getHours()
  h = h < 10 ? ('0' + h) : h
  var minute = date.getMinutes()
  var second = date.getSeconds()
  minute = minute < 10 ? ('0' + minute) : minute
  second = second < 10 ? ('0' + second) : second
  if (num === undefined) {
    var minute1 = 60000
    var hour = minute1 * 60
    var day = hour * 24
    var month = day * 30
    var nowTime = (new Date()).getTime() // 获取当前时间戳
    var ShiJianCha = nowTime - timestamp
    var monthC = ShiJianCha / month
    if (monthC >= 1) {
      return y + '-' + m + '-' + d + ' ' + h + ':' + minute
    } else {
      return m + '-' + d + ' ' + h + ':' + minute
    }
  } else {
    if (num === 0) {
      return y + '-' + m + '-' + d
    } else {
      return y + '-' + m + '-' + d + ' ' + h + ':' + minute + ':' + second
    }
  }
}
// 判断日期为今天、昨天、明天
const judgeDate = (data) => {
  try {
    // 昨天
    const yesterdayNum = new Date()
    yesterdayNum.setTime(yesterdayNum.getTime() - 24 * 60 * 60 * 1000)
    const yesterday = getDate(yesterdayNum, 0)
    // 今天
    const todayNum = new Date()
    todayNum.setTime(todayNum.getTime())
    const today = getDate(todayNum, 0)
    // 明天
    const tomorrowNum = new Date()
    tomorrowNum.setTime(tomorrowNum.getTime() + 24 * 60 * 60 * 1000)
    const tomorrow = getDate(tomorrowNum, 0)
    // data必须为日期格式 2021-01-01 12:00:00
    const time = data.split(' ')[0]
    const hours = data.split(' ')[1].split(':')[0] + ':' + data.split(' ')[1].split(':')[1]
    let timeStr = ''
    switch (time) {
      case yesterday:
        timeStr = '昨天' + hours
        break
      case today:
        timeStr = '今天' + hours
        break
      case tomorrow:
        timeStr = '明天' + hours
        break
      default:
        timeStr = data
    }
    return timeStr
  } catch (e) {
  }
}
// 允许页面滚动
const AddScroll = () => {
  document.body.style.overflow = 'visible'
}
// 禁止页面滚动
const RemoveScroll = () => {
  document.body.style.overflow = 'hidden'
}
// 字符串过滤
const stringFilter = (str) => {
  const num = str.length
  if (num > 7 && num < 17) {
    str.substring(3, num - 3)
    return num.replace(str, '****')
  }
}
// 网址urlEncode转码
const getUrlEncode = (str) => {
  function transform (s) {
    var hex = ''
    var i, t
    for (i = 0; i < s.length; i++) {
      t = hexfromdec(s.charCodeAt(i))
      if (t === '25') {
        t = ''
      }
      hex += '%' + t
    }
    return hex
  }
  function hexfromdec (num) {
    if (num > 65535) { return ('err!') }
    const first = Math.round(num / 4096 - 0.5)
    const temp1 = num - first * 4096
    const second = Math.round(temp1 / 256 - 0.5)
    const temp2 = temp1 - second * 256
    const third = Math.round(temp2 / 16 - 0.5)
    const fourth = temp2 - third * 16
    return ('' + getletter(third) + getletter(fourth))
  }
  function getletter (num) {
    if (num < 10) {
      return num
    } else {
      if (num === 10) { return 'A' }
      if (num === 11) { return 'B' }
      if (num === 12) { return 'C' }
      if (num === 13) { return 'D' }
      if (num === 14) { return 'E' }
      if (num === 15) { return 'F' }
    }
  }
  return transform(str)
}
// 地址跳转
const detailJump = (vueThat, id, navId, isDoing) => {
  let url = ''
  let urlOnOff = true
  switch (parseInt(navId)) {
    case 5: // 专家学者会客厅
      if (isDoing === 2) {
        urlOnOff = false
        vueThat.$message({
          message: '直播已结束，直播回放生成中，请您稍后点击观看！',
          type: 'warning'
        })
      } else if (isDoing === 5) {
        urlOnOff = true
        url = '/receptionVideoDetail/:id'
      } else {
        urlOnOff = true
        url = '/receptionDetail/:id'
      }
      break
    case 6: // 行业精英工作室
      if (isDoing === 2) {
        urlOnOff = false
        vueThat.$message({
          message: '直播已结束，直播回放生成中，请您稍后点击观看！',
          type: 'warning'
        })
      } else if (isDoing === 5) {
        urlOnOff = true
        url = '/receptionVideoDetail/:id'
      } else {
        urlOnOff = true
        url = '/receptionDetail/:id'
      }
      break
    case 7: // 专业精英工作室
      if (isDoing === 2) {
        urlOnOff = false
        vueThat.$message({
          message: '直播已结束，直播回放生成中，请您稍后点击观看！',
          type: 'warning'
        })
      } else if (isDoing === 5) {
        urlOnOff = true
        url = '/receptionVideoDetail/:id'
      } else {
        urlOnOff = true
        url = '/receptionDetail/:id'
      }
      break
    case 8: // 社区成员
      url = '/memberDetail/:id'
      break
    case 9: // 专家观点
      url = '/expertDetail/:id'
      break
    case 15: // 研讨沙龙
      if (isDoing === 2) {
        urlOnOff = false
        vueThat.$message({
          message: '直播已结束，直播回放生成中，请您稍后点击观看！',
          type: 'warning'
        })
      } else if (isDoing === 5) {
        urlOnOff = true
        url = '/discussVideoDetail/:id'
      } else {
        urlOnOff = true
        url = '/discussLiveDetail/:id'
      }
      break
    case 14: // 培训
      url = '/trainDetail/:id'
      break
    case 16: // 项目路演
      url = '/roadshowDetail/:id'
      break
    case 30: // 项目合作
      url = '/cooperationDetail/:id'
      break
    case 17: // 论坛
      url = '/forumDetail/:id'
      break
    case 18: // 公益项目
      url = '/welfareDetail/:id'
      break
    case 19: // 基金会
      url = '/foundationDetail/:id'
      break
    case 23: // 学术交流
      url = '/learningDetail/:id'
      break
    case 24: // 国际交流
      url = '/internationalDetail/:id'
      break
    case 26: // 项目合作
      url = '/objectDetail/:id'
      break
    case 20: // 课题报告
      url = '/ReportDetail/:id'
      break
    case 21: // 行业手册
      url = '/IndustryDetail/:id'
      break
    case 22: // 研究成果
      url = '/FindingsDetail/:id'
      break
    case 29: // 出版物
      url = '/bookDetail/:id'
      break
    // case 18: // 研究院
    //   url = '/researchDetail/:id'
    //   break
    // // case 19: // 国际交流
    // //   url = '/researchArticleDeatail/:id'
    // //   break
    // case 20: // 研究成果
    //   url = '/findingsDetail/:id'
    //   break
    // case 21: // 行业手册
    //   url = '/industryDetail/:id'
    //   break
    // case 22: // 报告下载
    //   url = '/reportDetail/:id'
    //   break
    // case 23: // 出版物
    //   url = '/bookDetail/:id'
    //   break
    // case 24: // 学术交流
    //   url = '/learningDetail/:id'
    //   break
    // case 100: // 社区生态回放
    //   url = '/receptionVideoDetail/:id'
    //   break
    // case 101: // 研讨沙龙回放
    //   url = '/discussVideoDetail/:id'
    //   break
  }
  if (urlOnOff) {
    const routeData = vueThat.$router.resolve({
      path: url,
      query: { id: id }
    })
    window.open(routeData.href, '_blank')
  }
}
// 模块判断
const navJudge = (navId) => {
  const info = {
    breadcrumb: '',
    breadcrumbName: '',
    path: ''
  }
  switch (navId) {
    case '5':
      info.breadcrumb = 'community'
      info.breadcrumbName = '专家学者会客厅'
      info.path = '/receptionLiveList'
      break
    case '6':
      info.breadcrumb = 'community'
      info.breadcrumbName = '行业精英工作室'
      info.path = '/receptionLiveList'
      break
    case '7':
      info.breadcrumb = 'community'
      info.breadcrumbName = '专业精英工作室'
      info.path = '/receptionLiveList'
      break
    case '8':
      info.breadcrumb = 'community'
      info.breadcrumbName = '交流室列表'
      info.path = '/memberList'
      break
    default:
    case '9':
      info.breadcrumb = 'community'
      info.breadcrumbName = '专家观点列表'
      info.path = '/expertList'
      break
    case '14':
      info.breadcrumb = 'union'
      info.breadcrumbName = '培训列表'
      info.path = '/trainList'
      break
    case '15':
      info.breadcrumb = 'union'
      info.breadcrumbName = '研讨沙龙'
      info.path = '/trainList'
      break
    case '16':
      info.breadcrumb = 'union'
      info.breadcrumbName = '项目路演'
      info.path = '/roadshowList'
      break
    case '17':
      info.breadcrumb = 'union'
      info.breadcrumbName = '论坛'
      info.path = '/forumList'
      break
    case '18':
      info.breadcrumb = 'union'
      info.breadcrumbName = '公益项目'
      info.path = '/welfareList'
      break
    case '19':
      info.breadcrumb = 'union'
      info.breadcrumbName = '基金会'
      info.path = '/foundationList'
      break
    case '20':
      info.breadcrumb = 'research'
      info.breadcrumbName = '课题报告'
      info.path = '/reportList'
      break
    case '21':
      info.breadcrumb = 'research'
      info.breadcrumbName = '行业手册'
      info.path = '/industryList'
      break
    case '22':
      info.breadcrumb = 'research'
      info.breadcrumbName = '研究成果'
      info.path = '/findingsList'
      break
    case '23':
      info.breadcrumb = 'research'
      info.breadcrumbName = '学术交流'
      info.path = '/learningList'
      break
    case '24':
      info.breadcrumb = 'research'
      info.breadcrumbName = '国际交流'
      info.path = '/internationalList'
      break
    case '26':
      info.breadcrumb = 'research'
      info.breadcrumbName = '项目合作'
      info.path = '/objectList'
      break
    case '29':
      info.breadcrumb = 'research'
      info.breadcrumbName = '出版物'
      info.path = '/bookList'
      break
  }
  return info
}
// 详情跳转
const allJump = (vueThat, type, id, navId, isDoing) => {
  let url = ''
  // type 为详情类型：1直播/2 视频/3 文章
  console.log(type)
  if (type === 2) {
    url = '/allVideoDetails'
  } else if (type === 3) {
    url = '/allArticleDetails'
  }
  const routeData = vueThat.$router.resolve({
    path: url,
    query: { id: id, nav: navId }
  })
  window.open(routeData.href, '_blank')
}
// 个人中心页面跳转
const userJump = (vueThat, rid) => {
  const routeData = vueThat.$router.resolve({
    path: '/personalCenter/:id',
    query: { id: rid }
  })
  window.open(routeData.href, '_blank')
}
// 判断是否为手机浏览器
const judgeMobile = () => {
  const ua = window.navigator.userAgent
  const agents = ['Android', 'iPhone', 'SymbianOS', 'Windows Phone', 'iPod', 'iPad']
  let isPC = false
  for (let i = 0, len = agents.length; i < len; i++) {
    if (ua.indexOf(agents[i]) > 0) {
      // 如果找到一个手机标识, 就设置为false并跳出循环
      isPC = true
      break
    }
  }
  if (isPC) {
    const href = window.location.href
    // 培训 论坛 研究成果 行业手册 报告下载 书籍 学术交流
    const details = ['roadshowDetail', 'forumDetail', 'FindingsDetail', 'industryDetail', 'reportDetail', 'bookDetail', 'learningDetail']
    for (let i = 0, len = details.length; i < len; i++) {
      if (href.indexOf(details[i]) > 0) {
        // 如果找到一个手机标识, 就设置为false并跳出循环
        window.location.href = href.replace(details[i], 'detailM')
        break
      }
    }
  }
  return isPC
}
export default {
  getNowFormatDate,
  getNowTime,
  getUnixTime,
  getDate,
  judgeDate,
  AddScroll,
  RemoveScroll,
  stringFilter,
  getUrlEncode,
  detailJump,
  navJudge,
  allJump,
  userJump,
  judgeMobile
}
